import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CertificadoService } from 'src/app/core/servicios/certificado.service';
import { ModalCargandoComponent } from 'src/app/shared/componentes/modal-cargando/modal-cargando.component';
import { ModalErrorComponent } from 'src/app/shared/componentes/modal-error/modal-error.component';

@Component({
  selector: 'app-validacion-certificado',
  templateUrl: './validacion-certificado.component.html',
  styleUrls: ['./validacion-certificado.component.css']
})
export class ValidacionCertificadoComponent implements OnInit {

  strCodificado: string = '';
  documentoVistaPrevia = '';

  constructor(private route: ActivatedRoute,
              private certificadoService: CertificadoService,
              private modalService: NgbModal) { }

  ngOnInit(): void {
    this.modalService.open(ModalCargandoComponent, { animation: true, backdrop: 'static', keyboard: false });
    this.strCodificado = this.route.snapshot.params.strCodificado;
    console.log('this.strCodificado');
    console.log(this.strCodificado);
    this.certificadoService.obtenerCertificadoGenerado(this.strCodificado).subscribe(
      res => {
        this.modalService.dismissAll();
        this.documentoVistaPrevia = res.body!.documentoVistaPrevia;
      },
      () => {
        this.modalService.dismissAll();
        const refError = this.modalService.open(ModalErrorComponent, { animation: true, backdrop: 'static', keyboard: false });
        refError.componentInstance.mensaje = 'Ha ocurrido un error al generar la vista previa';
      }
    );
  }

}